import { formatDate } from '@agentguru/helpers';
export function formatLastActivity(lastActivity) {
    return lastActivity ? formatDate(lastActivity, 'monthDayAndYear') : '-';
}
